import React from 'react'
import { Modal } from 'antd'

import imgLogo from 'assets/spiffme_600px.png'
import imgAppStore from 'assets/appstore.svg'
import imgGooglePlay from 'assets/googleplay.svg'
import './styles.css'

const GetAppDialog = ({visible, close}) => {
  return (
    <Modal
      wrapClassName="vertical-center-modal"
      visible={visible}
      footer={null}
      onCancel={close}
    >
      <div className="getapp">
        <img className="logo" src={imgLogo} alt="logo" />
        <p className="description">
          Please get the Free App to use <br /> <em>SpiffMe</em> as a Sales Rep
        </p>

        <a href="https://itunes.apple.com/us/app/spiff-me/id1345621267?ls=1&mt=8" target="_blank" rel="noopener noreferrer">
          <img className="store" src={imgAppStore} alt="Get App from App Store"  />
        </a>
        <a href="https://play.google.com/store/apps/details?id=com.spiffme" target="_blank" rel="noopener noreferrer">
          <img className="store" src={imgGooglePlay} alt="Get App from Google Play" />
        </a>

      </div>
    </Modal>
  )
}

export default GetAppDialog
